export default "__VITE_ASSET__B7rBn3xM__"